import React, { CSSProperties } from 'react';
import TileGrid from './TileGrid';
import { TileGridSectionProps } from './Types';
import useMediaQuery from '../../../hooks/useMediaQuery';

const TilesGridSection = ({
  tiles,
  backgroundImage,
  backgroundColor,
  tileFontStyle,
}: TileGridSectionProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

   const backgroundStyle: CSSProperties = backgroundImage
    ? {
          background: `url("${backgroundImage}")`,
          backgroundPosition: 'center',
          opacity: isMobile ? 0.9 : 0.6,
      }
    : {};

  return (
    <div
      style={backgroundStyle}
      className={`w-full flex justify-center items-center min-h-[${isMobile ? '460px' : '540px'}] relative`}
    >
      <div className="relative z-20 w-full h-full flex justify-center items-center">
        <TileGrid
          tiles={tiles}
          backgroundColor={backgroundColor}
          tileFontStyle={tileFontStyle}
        />
      </div>
    </div>
  );
};

export default TilesGridSection;
